import React, { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useIdleTimer } from 'react-idle-timer';

import ROUTES from 'enum/Routes';
import { logout } from 'store/common-scenario-actions';
import './styles.scss';

const ExpiryWarning = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const { tokenTTL } = user;
  const [remaining, setRemaining] = useState(tokenTTL * 1000);
  const [openPrompt, setOpenPrompt] = useState(false);

  const handleLogout = useCallback(() => {
    setOpenPrompt(false);
    dispatch(logout());
    history.push(ROUTES.LOGIN);
  }, [dispatch, history]);

  const { getRemainingTime } = useIdleTimer({
    onIdle: handleLogout,
    timeout: tokenTTL * 1000,
    throttle: 500,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      const reaminSec = Math.ceil(getRemainingTime() / 1000);
      setRemaining(reaminSec);
      if (reaminSec < 60) setOpenPrompt(true);
      else setOpenPrompt(false);
    }, 500);

    return () => {
      clearInterval(interval);
    };
  });

  return openPrompt ? (
    <div className="expiry-warning">
      You have been inactive for almost {Math.round(tokenTTL / 60)} minutes and you will be signed out in&nbsp;
      {remaining} seconds. You can change that in
      <a href="/v1/auth/profile">Profile Setting</a>
    </div>
  ) : null;
};

export default ExpiryWarning;
